import { render, staticRenderFns } from "./myService.vue?vue&type=template&id=80e483fc&scoped=true&"
import script from "./myService.vue?vue&type=script&lang=js&"
export * from "./myService.vue?vue&type=script&lang=js&"
import style0 from "./myService.vue?vue&type=style&index=0&id=80e483fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e483fc",
  null
  
)

export default component.exports